import { handleActions, combineActions } from 'redux-actions';
import {
  appCreationInitialized,
  appCreationSucceeded,
  appCreationFailed,
} from '@piwikpro/apps-crate';

interface CreateUserState {
  isLoading: boolean
}

const initialState: CreateUserState = {
  isLoading: false,
};

export default handleActions<CreateUserState>({
  [appCreationInitialized.toString()]: state => ({
    ...state,
    isLoading: true,
  }),
  [combineActions(appCreationSucceeded, appCreationFailed).toString()]: () => initialState,
}, initialState);
